import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  name: string;
  role: string;
  text: string;
}
const testimonials: Testimonial[] = [{
  name: 'Lucas M.',
  role: 'Compró su auto — Villa Lugano, CABA',
  text: 'Estaba en Veraz y no creía que iba a poder comprar un auto. Flash & Go me asesoró, me consiguieron financiación y en dos semanas ya tenía mi Cronos. Increíble el trato.'
}, {
  name: 'Sebastián R.',
  role: 'Conductor Uber — Flores, CABA',
  text: 'Arrancé con el turno de 12 horas para probar y ahora estoy a cargo las 24. Los autos están en perfecto estado y el equipo siempre te da una mano cuando necesitás algo.'
}, {
  name: 'Ezequiel T.',
  role: 'Conductor — Lomas de Zamora, GBA',
  text: 'Lo mejor que hice fue elegir el alquiler con opción a compra. Llevo 9 meses trabajando y en 3 meses más el auto es mío. Sin haber puesto casi nada al principio.'
}, {
  name: 'Marcela F.',
  role: 'Consignación — Caballito, CABA',
  text: 'Dejé mi auto en consignación y en menos de 3 semanas ya estaba vendido. Se encargaron de todo, las fotos, los interesados, el papeleo. Yo no moví un dedo.'
}, {
  name: 'Hernán D.',
  role: 'Inversor — Palermo, CABA',
  text: 'Empecé invirtiendo U$S 15.000 y cobro puntual todos los meses. Es la mejor decisión que tomé para dolarizar mis ahorros. El equipo de Flash & Go es muy serio y transparente.'
}];
function Stars() {
  return <div className="flex gap-0.5 mb-4" aria-label="5 de 5 estrellas" data-id="element-335">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-336" />)}
    </div>;
}
function TestimonialCard({
  t
}: {
  t: Testimonial;
}) {
  return <div className="bg-[#1A1A1A] border-t-2 border-t-brand-gold p-6 rounded-b-lg shadow-lg h-full flex flex-col" data-id="element-337">
      <Stars data-id="element-338" />
      <p className="text-brand-white text-sm leading-[1.6] mb-6 flex-grow" data-id="element-339">
        “{t.text}”
      </p>
      <div className="mt-auto" data-id="element-340">
        <p className="text-brand-white font-bold text-[15px]" data-id="element-341">{t.name}</p>
        <p className="text-brand-white/50 text-[13px]" data-id="element-342">{t.role}</p>
      </div>
    </div>;
}
export function Testimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const cardWidth = el.scrollWidth / testimonials.length;
    setActiveIndex(Math.round(el.scrollLeft / cardWidth));
  };
  const scrollToIndex = (index: number) => {
    const el = scrollRef.current;
    if (!el) return;
    const cardWidth = el.scrollWidth / testimonials.length;
    el.scrollTo({
      left: cardWidth * index,
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-brand-black relative" data-id="element-343">
      <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-344">
        {/* Top divider */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent mb-16" data-id="element-345"></div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-346">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-4" data-id="element-347">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-brand-gold text-lg font-medium" data-id="element-348">
            ★★★★★ 4.9 — Cientos de clientes satisfechos en todo el país
          </p>
        </motion.div>

        {/* Desktop grid */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="hidden md:grid grid-cols-2 gap-6" data-id="element-349">
          {testimonials.map((t, i) => <TestimonialCard key={i} t={t} data-id="element-350" />)}
        </motion.div>

        {/* Mobile carousel */}
        <div className="md:hidden" data-id="element-351">
          <div ref={scrollRef} onScroll={handleScroll} className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 -mx-5 px-5 scrollbar-hide" style={{
          scrollbarWidth: 'none'
        }} data-id="element-352">
            {testimonials.map((t, i) => <div key={i} className="snap-center shrink-0 w-[85%]" data-id="element-353">
                <TestimonialCard t={t} data-id="element-354" />
              </div>)}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-355">
            {testimonials.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} className={`h-2 rounded-full transition-all ${activeIndex === i ? 'w-6 bg-brand-gold' : 'w-2 bg-brand-white/30'}`} data-id="element-356" />)}
          </div>
        </div>
      </div>
    </section>;
}